import React from 'react';
import WaitCube from '../../WaitCube.js'
import {_GPY,__GPYPost , __GPYGet} from '../../env.js'
import Draggable from 'react-draggable';
import {ResizableBox} from 'react-resizable';
import Helper from '../Helper.js'
import GpyFileUpload from '../gametypes/lib/GpyFileUpload.js'
import {SwatchesPicker} from 'react-color';
import $ from "jquery";

class OverlayConfig extends React.Component {
  constructor(props) {
   super(props);
   //var w = 3840;
   var w = window.innerWidth - 350 - 50; // 960;
   this.state = {
     overlaysIsLoaded : false,
     overlays : {},
     currentOverlay: {id:-1,transition:"fadeFastInOut"},
     currentOverlayElement : {id:-1},
     currentLayout: {id:-1,name:""},
     layoutsIsLoaded : false,
     layouts : {},
     doingStore:false,
     unsave: false,
     width:w,
     height: Math.round(w/1.7777777778),
     admin: {overlayName:"",overlayElementName:"",overlayLockAspectRatio:false,copyToName:""},
     showColorPicker:false,
     afterUpload:false,

     _EDIT_X:false,
     _EDIT_X_NUM:0.00,
     _EDIT_Y:false,
     _EDIT_Y_NUM:0.00,
     _EDIT_W:false,
     _EDIT_W_NUM:0.00,
     _EDIT_H:false,
     _EDIT_H_NUM:0.00,
   };
  }

  updateDimensions () {
     var w = window.innerWidth - 350 - 50; // 960;
     var h = Math.round(w/1.7777777778);
     if(this.state.overlaysIsLoaded) {
         var ol = this.state.overlays;
         Object.keys(ol).forEach(key => {
           Object.keys(ol[key].overlay.elements).forEach(eKey => {
                var e = ol[key].overlay.elements[eKey].element;
                e.x = Helper.toXPos(parseFloat(e._x),w);
                e.y = Helper.toYPos(parseFloat(e._y),h);
                e.width = Helper.toXPos(parseFloat(e._width),w);
                e.height = Helper.toYPos(parseFloat(e._height),h);
           });
         });
         this.setState({width: w, height: h,overlays:ol});
    } else {
        this.setState({width: w, height: h});
    }
  }

  componentDidMount(){
    window.addEventListener("resize",()=>{this.updateDimensions();});
    this.getLayouts();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", ()=>{this.updateDimensions();});
  }

  createOrUpdateLayout(){
    __GPYPost('createOrUpdateLayout',this.state.currentLayout,(res)=>{
       this.getLayouts();
    });
  }

  deleteLayout(){
    __GPYPost('deleteLayout',this.state.currentLayout,(res)=>{
       this.getLayouts();
    });
  }

  getLayouts(){
    __GPYGet('getLayouts',(res)=>{
      this.setState({
        layoutsIsLoaded: true,
        layouts: res.Layouts.Layout,
        currentOverlay: {id:-1},
        currentLayout: {id:-1},
      });
      if(_GPY.uiStates.currentOverlayLayout !== undefined) {
        this.setCurrentLayout( parseInt(_GPY.uiStates.currentOverlayLayout));
      }
      this.getOverlays();
    },(err)=>{
      this.setState({
        layoutsIsLoaded: false,
        currentLayout: {id:-1,name:""},
      })
    });
  }

    setCurrentLayout(layoutId) {
      if(layoutId === -1) {
          this.setState({currentLayout:{id:-1,name:""}});
          this.getOverlays(-1);
      }

      this.state.layouts.forEach((t) => {
          console.log(t,layoutId,t.id === layoutId);
          if(t.id === layoutId) {
            this.setState({currentLayout:t});
            this.getOverlays(t.id);
          }
      });

    }

  onChangeLayoutName(e) {
    var cl = this.state.currentLayout;
    cl.name = e.target.value;
    cl.id = -1;
    this.setState({currentLayout:cl});
  }

  changeLayout(e){
      var layoutId = parseInt(e.target.value);
      __GPYPost('setUIState',{currentOverlayLayout: layoutId});
      this.setState({overlaysIsLoaded:false, currentOverlayElement : {id:-1}},() => {
          this.setCurrentLayout(layoutId);
      });
  }



  getOverlays(id,preSelect) {
    if(id === undefined) {
      id = this.state.currentLayout.id;
    }

    __GPYPost('getOverlays',{layoutPk:id},(res)=>{

      Object.keys(res.Overlays.overlay).forEach(key => {

        Object.keys(res.Overlays.overlay[key].overlay.elements).forEach(eKey => {
             var e = res.Overlays.overlay[key].overlay.elements[eKey].element;

             e._x = e.x;
             e._y = e.y;
             e._width  = e.width;
             e._height = e.height;

             e.x = Helper.toXPos(parseFloat(e.x),this.state.width);
             e.y = Helper.toYPos(parseFloat(e.y),this.state.height);
             e.width = Helper.toXPos(parseFloat(e.width),this.state.width);
             e.height = Helper.toYPos(parseFloat(e.height),this.state.height);
        });
      });

      if(preSelect===undefined) {
        preSelect = -2;
      }
      var ordered = {};
      var preSelected = {id:-1};
      Object.keys(res.Overlays.overlay).sort().forEach(function(key) {
          ordered[key] = res.Overlays.overlay[key];
          if(key === preSelect) {
            preSelected = res.Overlays.overlay[key].overlay;
          }
      });
      this.setState({
        overlaysIsLoaded: true,
        overlays: ordered,
        currentOverlay: preSelected,
        doingStore:false,
      });
    });
	}


  store(){
    var olId = this.state.currentOverlay.key;

    this.setState({doingStore:true});

    var ol = JSON.parse(JSON.stringify(this.state.overlays));
    Object.keys(ol).forEach(key => {
      console.log(key,ol[key].overlay);
      Object.keys(ol[key].overlay.elements).forEach(eKey => {
           var e = ol[key].overlay.elements[eKey].element;
           e.x = Helper.toXPercent(e.x,this.state.width);
           e.y = Helper.toYPercent(e.y,this.state.height);
           e.width = Helper.toXPercent(e.width,this.state.width);
           e.height = Helper.toYPercent(e.height,this.state.height);
      });
    });

    __GPYPost('storeOverlays',{overlays:ol,layout:this.state.currentLayout},(res)=>{
         this.getOverlays(this.state.currentLayout.id,olId);
    });
  }

  onControlledDragStop(element, e, position) {
		 if(element !== undefined) {
			 element.x = position.x;
			 element.y = position.y;

       element._x = Helper.toXPercent(position.x,this.state.width);;
			 element._y = Helper.toYPercent(position.y,this.state.height);
		 }
		 this.setState({unsave:true});

  }
  onStart(element) {
    if(element !== undefined) {
      this.forceUpdate();
    }
  }

  onSelectOutput(o) {
    this.setState({currentOverlay:o,currentOverlayElement:{id:-1}});
  }

  onSelectElement(e) {
    this.setState({currentOverlayElement:e});
  }

  setAlign(element,value) {
    element.align = value;
    this.setState({unsave:true});
  }

  setVAlign(element,value) {
    element.valign = value;
    this.setState({unsave:true});
  }

  onChangeTransition(e){
      var ol  = this.state.currentOverlay;
      ol.transition = e.target.value;
      this.setState({currentOverlay:ol});
  }

  onChangeLayouter(e){
      var ol  = this.state.currentOverlay;
      ol.layouter = e.target.value;
      this.setState({currentOverlay:ol});
  }

  onChangeEventName(e){
      var ol  = this.state.currentOverlay;
      ol.eventName = e.target.value;
      this.setState({currentOverlay:ol});
  }
  onResize(element,e,hnd) {
      element.width = hnd.size.width;
      element.height = hnd.size.height;
      element._width = Helper.toXPercent(hnd.size.width,this.state.width);
      element._height = Helper.toYPercent(hnd.size.height,this.state.height);
      this.forceUpdate();
  }

  onAdminChange(key,e) {
    var adm = this.state.admin ;
    adm[key] = e.target.value ;
    this.setState({admin: adm});
  }

  onAdminChangeCheckbox(key,e) {
    var adm = this.state.admin ;
    adm[key] = !adm[key];
    this.setState({admin: adm});
    console.log(key,this.state.admin[key]);
  }

  adminCreateOverlay(){
    __GPYPost('adminCreateOverlay',this.state.admin,(res)=>{
       this.getOverlays();
    });
  }

  adminCopyOverlay() {
    console.log("copy",this.state.currentOverlay.key,this.state.admin.copyToName);
    this.setState({doingStore:true},()=> {
      __GPYPost('adminCopyOverlay',{overlayName : this.state.currentOverlay.key , copyTo : this.state.admin.copyToName},(res)=>{
         this.getOverlays();
         this.setState({doingStore:false});
      });
    });
  }


  adminCreateOverlayElement() {
    var adm = this.state.admin;
    adm.overlayElementPk = this.state.currentOverlay.id;

    __GPYPost('adminCreateOverlayElement',adm,(res)=>{
       this.getOverlays();
    });
  }

  handleColorChangeComplete(c){
    var tmp = this.state.currentOverlayElement;
    if(tmp!==undefined) {
      tmp.fontColor = c.hex;
      this.setState({ currentOverlayElement: tmp,showColorPicker:false});
    }
  }

  onChangeDataSouce(e){
      var tmp = this.state.currentOverlayElement;
      tmp.dataSource = e.target.value;
      this.setState({currentOverlayElement:tmp});
  }

  onChangeImageSouce(e){
      if(e.target.value === undefined ){
          return;
      }
      var tmp = this.state.currentOverlayElement;
      tmp.imageSrc = e.target.value;
      this.setState({currentOverlayElement:tmp});
  }


  onChangeValue(elementName,e){
    if(e.target.value === undefined){
        return;
    }
    var tmp = this.state.currentOverlayElement;
    tmp[elementName] = e.target.value;
    this.setState({currentOverlayElement:tmp});
  }

  onChangeElementOverlay(e) {
    var id = parseInt(e.target.value);
    if(id<0) {
      this.setState({currentOverlay:{id:-1,transition:"fadeFastInOut"},currentOverlayElement:{id:-1}});
    }
    var ol = this.state.overlays;
    Object.entries(ol).forEach(([key,v],i) => {
        if(id === v.overlay.id) {
            this.setState({currentOverlay:v.overlay,currentOverlayElement:{id:-1}});
            return;
        }
    });
  }

  onChangeElementFont(e){
    if(e.target.value === undefined || e.target.value === ''){
        return;
    }
    var tmp = this.state.currentOverlayElement;
    tmp.font = e.target.value;
    this.setState({currentOverlayElement:tmp});
  }

  onChangeElementlLineHeight(e){
    if(e.target.value === undefined || e.target.value === ''){
        return;
    }
    var tmp = this.state.currentOverlayElement;
    tmp.lineHeight = e.target.value;
    this.setState({currentOverlayElement:tmp});
  }

  onChangeElementOpacity(e){
      if(e.target.value === undefined || e.target.value === ''){
          return;
      }
      var tmp = this.state.currentOverlayElement;
      tmp.opacity = parseFloat(e.target.value)/100;
      this.setState({currentOverlayElement:tmp});
  }

  onChangeElementFontSize(e){
    if(e.target.value === undefined || e.target.value === ''){
        return;
    }
    var tmp = this.state.currentOverlayElement;
    tmp.fontSize = e.target.value;
    this.setState({currentOverlayElement:tmp});
  }

  onChangeElementType(e){
    if(e.target.value === undefined || e.target.value === ''){
        return;
    }
    var tmp = this.state.currentOverlayElement;
    tmp.elementType = e.target.value;
    this.setState({currentOverlayElement:tmp});
  }

  onChangeElementCords(field, side, e) {
    console.log(field, side, e);
    if(e.target.value === undefined || e.target.value === '' || isNaN(e.target.value)) {
      return;
    }
    var v = parseFloat(e.target.value);
    if(v<0 || v > 100 ) {
      return;
    }

    var tmp = this.state.currentOverlayElement;
    tmp[field] = Helper.toXPos(parseFloat(e.target.value),side);
    this.setState({currentOverlayElement:tmp});
  }

  toogleColorPicker() {
    this.setState({showColorPicker:!this.state.showColorPicker })

  }

  isBrightColor(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if(result === undefined || result === null) {
      return false;
    }
    var rgb = {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
    };
    if( ((rgb.r+rgb.g+rgb.b)/3)>128) return true;
    return false;
  }

  imageLoaded() {

    if(this.state.afterUpload && (this.state.overlaysIsLoaded && this.state.currentOverlay.elements !== undefined && this.state.currentOverlayElement.id>0)){
      var myImg = document.querySelector("#elementImagePreview");
      if(myImg !== undefined && myImg !== null) {
        var realWidth = myImg.naturalWidth;
        var realHeight = myImg.naturalHeight;
        console.log("Original width=" + realWidth, "Original height=" + realHeight);

        if((realWidth+realHeight) > 0) {
          var pw = Helper.toXPercent(realWidth, 3840);
          var ph = Helper.toYPercent(realHeight, 2160);
          var newWpx = Helper.toXPos(pw,this.state.width);
          var newHpx = Helper.toYPos(ph,this.state.height)
          console.log("width=" +  newWpx+ ", height=" + newHpx);
          var tmp = this.state.currentOverlayElement;
             tmp.width = newWpx;
             tmp.height = newHpx;
             tmp.lockAspectRatio = 'true';
             console.log("dataSource", tmp.imageSrc);
             this.setState({currentOverlayElement:tmp});
             // this.forceUpdate();
        }
      }
        this.setState({afterUpload:false});
    }

  }

  onEnableElement(){
    var tmp = this.state.currentOverlayElement;
    tmp.enable = !tmp.enable;
    this.setState({currentOverlayElement:tmp});
  }

  onElementImageUpload(f){
      console.log("onElementImageUpload",f);
      var tmp = this.state.currentOverlayElement;
      tmp.imageSrc = f;
      this.setState({currentOverlayElement:tmp,afterUpload:true});
  }

  sortProperties(obj) {
    var sortable=[];
	  for(var key in obj) {
		    if(obj.hasOwnProperty(key)) {
			     sortable.push([key, obj[key]]);
           sortable.sort(function(a, b) {
			         return a[1].element.zindex - b[1].element.zindex;
		       });
        }
    }
	  return sortable;
  }

  changeZindex(e,count) {
    e.element.zindex = count + e.element.zindex;
    this.setState({currentOverlay:this.state.currentOverlay})
  }

	render() {
/*
    var isUnsave = function (unsave ,prefix) {
        if(unsave){
          return prefix + "success";
        } else {
          return prefix + "primary disabled";
        }
    }

    var isUpdate = function (current, prefix) {
        if(current.id>0){
          return prefix + "danger";
        } else {
          return prefix + "danger disabled";
        }
    }
*/

    const ol = this.state.overlays;

    const fontSizes = [1,1.5,2,2.5,3,3.5,4,5,6,7,8,9,10,12,14,16,18,20,25,30,35,40,45,50,55,60,65,70];
    return (
      <div>

      <div className="row">
          <div className="col-12">
              <div className="card bg-light ">
                  <div className="card-header">{_GPY.i18n.get('gametype_overlayconfig_layout_headline')}</div>
                    <div className="card-body">
                      <div className="form-group">

                          <div className="row">
                            <div className="col-4">
                              <select className="form-control" onChange={this.changeLayout.bind(this)} value={this.state.currentLayout.id}>
                                    <option key="-1" value="-1">{_GPY.i18n.get('gametype_overlayconfig_layout_dropdown_default_value')}</option>
                                    {this.state.layoutsIsLoaded ? this.state.layouts.map((t) =>
                                      <option key={t.id} value={t.id}>{t.name}</option>
                                    ): "" }
                              </select>
                          </div>

                          <div className="col-1">

                              {this.state.currentLayout.id>0?
                                <div>
                                <button type="button" onClick={()=>{this.setState({currentLayout:{id:-1,name:""}},()=>{$('#overlayLayoutName').focus()})}} className="btn btn-secondary ml-2"><span className="glyphicon glyphicon-plus" aria-hidden="true"></span></button>
                                <button type="button" onClick={this.deleteLayout.bind(this)} className="btn btn-danger ml-2"><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
                                </div>
                              :
                                <div>
                                <button type="button" className="btn btn-light ml-2 disabled"><span className="glyphicon glyphicon-plus" aria-hidden="true"></span></button>
                                <button type="button" className="btn btn-light ml-2 disabled"><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
                                </div>
                              }
                            </div>

                            <div className="col-2">

                            </div><div className="col-4">
                              <input onChange={this.onChangeLayoutName.bind(this)} defaultValue={this.state.currentLayout.name} id="overlayLayoutName" name="gameName" type="text"  className="form-control" placeholder="Enter your Layoutname"/>
                            </div>

                              <div className="col-1">

                                {this.state.currentLayout.name !== undefined && this.state.currentLayout.name !==''?
                                <button type="button" onClick={this.createOrUpdateLayout.bind(this)} className="btn btn-success"><span className="glyphicon glyphicon-ok" aria-hidden="true"></span></button>
                                :
                                <button type="button" onClick={this.createOrUpdateLayout.bind(this)} className="btn btn-secondary"><span className="glyphicon glyphicon-plus" aria-hidden="true"></span></button>
                              }
                            </div>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      {_GPY.uiStates.userLvl >= _GPY.USER_EXPERT && this.state.currentLayout.id <= 0 ?
      <div className="row">
          <div className="col-12">
            <div className="card text-white bg-danger mb-3">
                <div className="card-header">AdminPanel - Default-Layout</div>
                <div className="card-body">
                  <form className="form-inline">
                    <div className="form-group  m-2">
                      <input onChange={this.onAdminChange.bind(this,"overlayName")} value={this.state.admin.overlayName} name="overlayName" type="text"  className="form-control" placeholder="Enter new overlay Name"/>
                    </div>
                      {this.state.doingStore?  <button type="button" className="btn btn-danger disabled">Add Overlay</button>
                      :   <button type="button" onClick={this.adminCreateOverlay.bind(this)} className="btn btn-primary">Add Overlay</button>
                      }
                  </form>
                    <hr/>
                  {this.state.currentOverlay.id>0?
                    <form className="form-inline">
                      <div className="form-group m-2">
                        <input onChange={this.onAdminChange.bind(this,"overlayElementName")} value={this.state.admin.overlayElementName} name="overlayElementName" type="text"  className="form-control" placeholder="Enter new element Name"/>
                      </div>
                       <div className="form-check m-2">
                          <input onChange={this.onAdminChangeCheckbox.bind(this,"overlayLockAspectRatio")} defaultChecked={this.state.admin.overlayLockAspectRatio} className="form-check-input" type="checkbox" id="gridCheck1"/>
                          <label className="form-check-label">LockAspectRatio</label>
                      </div>
                      {this.state.doingStore? <button type="button" className="btn btn-danger disabled">Add Overlay Element</button>
                        :  <button type="button"  onClick={this.adminCreateOverlayElement.bind(this)}  className="btn btn-primary">Add Overlay Element</button>
                      }
                    </form>
                    :""}
                    <hr/>

                    <form className="form-inline">
                      <select className="form-control" value={this.state.currentOverlay.id}  onChange={this.onChangeElementOverlay.bind(this)}>
                          <option key={-1} value="-1">{_GPY.i18n.get('gametype_overlayconfig_configuration_dropdown_default_value')}</option>
                          {this.state.overlaysIsLoaded ? Object.entries(ol).map(([key,v],i) =>
                            <option key={v.overlay.id} value={v.overlay.id}>{v.overlay.key}</option>
                          ):""}
                      </select>
                      <div className="form-group  m-2">
                        <input onChange={this.onAdminChange.bind(this,"copyToName")} value={this.state.admin.copyToName} name="copyToName" type="text"  className="form-control" placeholder="Enter new overlay Name"/>
                      </div>

                      {this.state.doingStore? <button type="button" className="btn btn-danger disabled">CopyOverlay</button>
                      : <button type="button" onClick={this.adminCopyOverlay.bind(this)} className="btn btn-primary">CopyOverlay</button>
                      }

                    </form>

                </div>
            </div>
          </div>
      </div>
      :""}

      <div className="card bg-light mt-1">
          <div className="card-header">{_GPY.i18n.get('gametype_overlayconfig_configuration_headline_prefix')}{this.state.currentLayout.name}</div>
            <div className="card-body">
              {this.state.currentLayout.id > 0 || _GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?

            <div className="row">
                <div className="col p-1 pl-3" style={{maxWidth:"300px"}}>
                  <div className="form-group">
                    <select className="form-control" value={this.state.currentOverlay.transition} onChange={(e)=>this.onChangeTransition(e)}>
                        <option value="fadeSlowInOut">fadeSlowInOut</option>
                        <option value="fadeFastInOut">fadeFastInOut</option>
                        <option value="blurFadeInOut">blurFadeInOut</option>

                        <option value="slideSmallFromLeft">slideSmallFromLeft</option>
                        <option value="slideSmallFromRight">slideSmallFromRight</option>
                        <option value="slideSmallFromDown">slideSmallFromDown</option>
                        <option value="slideSmallFromUp">slideSmallFromUp</option>

                        <option value="rotation90">rotation90</option>
                        <option value="rotation360AndScale">rotation360AndScale</option>
                        <option value="rotation15FromLeft">rotation15FromLeft</option>
                        <option value="rotation15FromRight">rotation15FromRight</option>

                        <option value="scaleFromCenterCenter">scaleFromCenterCenter</option>
                        <option value="scaleFromTopCenter">scaleFromTopCenter</option>
                        <option value="scaleFromTopLeft">scaleFromTopLeft</option>
                        <option value="scaleFromTopRight">scaleFromTopRight</option>
                        <option value="scaleFromDownRight">scaleFromDownRight</option>
                        <option value="scaleFromDownLeft">scaleFromDownLeft</option>
                        <option value="scaleFromDownCenter">scaleFromDownCenter</option>

                    </select>
                   </div>
                </div>

{_GPY.uiStates.userLvl >= _GPY.USER_EXPERT && this.state.currentLayout.id <= 0 ?
                <>
                <div className="col p-1 pl-3">
                  <div className="form-group">
                    <select className="form-control" value={this.state.currentOverlay.layouter} onChange={(e)=>this.onChangeLayouter(e)}>
                        <option value="Overlay">Overlay</option>
                        <option value="LineUp">LineUp</option>
                        <option value="FreeText">FreeText</option>
                        <option value="Crawl">Crawl</option>
                        <option value="Credits">Credits</option>
                    </select>
                   </div>
                </div>

                <div className="col p-1 pl-3">
                  <div className="form-group">
                    <input type="text" className="form-control" value={this.state.currentOverlay.eventName!==undefined?this.state.currentOverlay.eventName:""} onChange={(e)=>this.onChangeEventName(e)} />
                    {	_GPY.toggleButtonList!==undefined?
                      <div className="form-group"><select onChange={(e)=>{
                        var list = Array.from(e.target.selectedOptions, option => option.value);
                        var ol  = this.state.currentOverlay;
                        ol.eventName = list.join(',');
                        this.setState({currentOverlay:ol});
                      }} multiple class="form-control">
                            {_GPY.toggleButtonList.map((e)=>{
                                return (<option>{e}</option>);
                            })}
                      </select></div>
                    :""}
                   </div>
                </div>
                </>
:""}
                <div className="col p-1">
                  {this.state.doingStore? <button className="btn btn-danger disabled">{_GPY.i18n.get('gametype_overlayconfig_configuration_button_dostore_prefix')} {this.state.currentLayout.name} {_GPY.i18n.get('gametype_overlayconfig_configuration_button_dostore_suffix')}</button>
                  : <button className="btn btn-primary" onClick={this.store.bind(this)}>{_GPY.i18n.get('gametype_overlayconfig_configuration_button_store_prefix')} {this.state.currentLayout.name} {_GPY.i18n.get('gametype_overlayconfig_configuration_button_store_suffix')}</button>
                  }
                </div>
          </div>

          :""}


          <div className="row" style={{display: this.state.doingStore?"none":"flex"}}>
              <div className="col p-1 pl-3" style={{maxWidth:"350px"}}>


              <select className="form-control" value={this.state.currentOverlay.id}  onChange={this.onChangeElementOverlay.bind(this)}>
                  <option key={-1} value="-1">{_GPY.i18n.get('gametype_overlayconfig_configuration_dropdown_default_value')}</option>
                  {this.state.overlaysIsLoaded ? Object.entries(ol).map(([key,v],i) =>
                  <option key={v.overlay.id} value={v.overlay.id}>{v.overlay.key}</option>
                  ):""}
              </select>


                  <div className="list-group">
                            {this.state.overlaysIsLoaded ? Object.entries(ol).map(([key,v],i) =>
                              <div key={key}>


                              <div className="list-group">
                              {this.state.overlaysIsLoaded && this.state.currentOverlay.elements !== undefined && v.overlay.id === this.state.currentOverlay.id?
                                  this.sortProperties(this.state.currentOverlay.elements).map(([key,e],i) =>

                                <div key={e.element.key}  onClick={this.onSelectElement.bind(this,e.element)} className={e.element.id === this.state.currentOverlayElement.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-secondary list-group-item-action flex-column align-items-start pointer"}>
                                   <div className="pl-3 d-flex w-100 justify-content-between">
                                   <div>
                                    <span className="glyphicon glyphicon-unchecked" aria-hidden="true"></span>
                                    <small className="ml-3">{key}</small>
                                    </div>

                                    {_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
                                    <div>
                                    <small className="ml-3 mr-1">{e.element.zindex}</small>
                                    <button className="btn btn-sm btn-light mr-1" onClick={ this.changeZindex.bind(this,e,1) }><span className="glyphicon glyphicon-plus" aria-hidden="true"></span></button>
                                    <button className="btn btn-sm btn-light" onClick={ this.changeZindex.bind(this,e,-1) }><span className="glyphicon glyphicon-minus" aria-hidden="true"></span></button>
                                    </div>
                                    :""}

                                  </div>
                                </div>
                              ):""}
                              </div>
                            </div>
                            ) :  <WaitCube/>  }
                   </div>
              </div>


            <div className="col p-1 pt-1" style={{width:this.state.width+"px"}}>
                <div className="m-0" style={{position: "relative", width:this.state.width+"px",height:this.state.height+"px", backgroundColor: 'rgba(0,0,0,0.3)'}}>


                    <div style={{ position: "absolute",left:"0px",top:"0px", width:this.state.width+"px", height: Helper.toYPos(5,this.state.height)+"px",  backgroundColor: 'rgba(255,0,0,0.2)'}}/>
                    <div style={{ position: "absolute",left:"0px",top: (this.state.height-Helper.toYPos(5,this.state.height))+"px", width:this.state.width+"px", height: Helper.toYPos(5,this.state.height)+"px",  backgroundColor: 'rgba(255,0,0,0.2)'}}/>

                    <div style={{ position: "absolute", left:"0px" ,top: Helper.toYPos(5,this.state.height)+"px", width: Helper.toXPos(5,this.state.width)+"px", height: (this.state.height-(2*Helper.toYPos(5,this.state.height)))+"px",  backgroundColor: 'rgba(255,0,0,0.2)'}}/>
                    <div style={{ position: "absolute", left: (this.state.width - Helper.toXPos(5,this.state.width))+"px" ,top: Helper.toYPos(5,this.state.height)+"px", width: Helper.toXPos(5,this.state.width)+"px", height: (this.state.height-(2*Helper.toYPos(5,this.state.height)))+"px",  backgroundColor: 'rgba(255,0,0,0.2)'}}/>

                    <div style={{ position: "absolute",left:((this.state.width/2)-2)+"px",top:"0px", width:"4px", height:this.state.height+"px",  backgroundColor: 'rgba(0,0,0,0.3)'}}/>
                    <div style={{ position: "absolute",left: "0px", top:((this.state.height/2)-2)+"px", width:this.state.width+"px", height:"4px",  backgroundColor: 'rgba(0,0,0,0.3)'}}/>

                    <div style={{ position: "absolute",left: "0px", top:((this.state.height/3)-1)+"px", width:this.state.width+"px", height:"2px",  backgroundColor: 'rgba(0,0,0,0.1)'}}/>
                    <div style={{ position: "absolute",left: "0px", top:((this.state.height/3)*2-1)+"px", width:this.state.width+"px", height:"2px",  backgroundColor: 'rgba(0,0,0,0.1)'}}/>
                    <div style={{ position: "absolute",left:((this.state.width/3)*2-1)+"px",top:"0px", width:"2px", height:this.state.height+"px",  backgroundColor: 'rgba(0,0,0,0.1)'}}/>
                    <div style={{ position: "absolute",left:((this.state.width/3)-1)+"px",top:"0px", width:"2px", height:this.state.height+"px",  backgroundColor: 'rgba(0,0,0,0.1)'}}/>

                    {this.state.overlaysIsLoaded && this.state.currentOverlay.elements !== undefined ? Object.entries(this.state.currentOverlay.elements).map(([key,e],i) => {



                        if(e.element.id === this.state.currentOverlayElement.id){
                          return (
                            <Draggable cancel="span" key={e.element.key} bounds="parent" onStart={this.onStart.bind(this,e.element)} position={e.element} onStop={this.onControlledDragStop.bind(this,e.element)}>
                              <div style={{position: "absolute",zIndex:"150",}} key={e.element.key}>

                                <div style={{position: "absolute",top:"-17px",left:"0px",width:"200px",lineHeight: "1"}}>
                                  <span style={{color:'rgba(0,0,0,0.7)',fontSize:"10px"}}>{e.element.title}</span>
                                </div>

                                <ResizableBox onResize={this.onResize.bind(this,e.element)} lockAspectRatio={e.element.lockAspectRatio==='true'?true:false} width={e.element.width} height={e.element.height} minConstraints={[2, 2]} maxConstraints={e.element.type==='image'?[e.element.width, e.element.height]:[this.state.width, this.state.height]}>
                                  {e.element.elementType  === 'image' ?
                                      <div style={{opacity: '0.90',backgroundImage: 'url("'+_GPY.resource("upload/"+e.element.imageSrc)+'")',backgroundSize: "cover", overflow: "hidden", width: "100%", height:"100%",cursor: "grab",display: "flex", alignItems: e.element.valign, justifyContent: e.element.align, border: "solid 1px #555"}}></div>
                                  :
                                      <div style={{overflow: "hidden", width: "100%", height:"100%",cursor: "grab",display: "flex", alignItems: e.element.valign, justifyContent: e.element.align, border: "solid 1px #555",background: 'rgba(0,255,0,0.4)'}}>

                                        {e.element.elementType==='dataText' || e.element.elementType==='text'?
                                            <span  style={{zIndex:-1,fontFamily: e.element.font===undefined?"Arial, Helvetica, sans-serif":e.element.font, color:e.element.fontColor,fontSize: e.element.fontSize===undefined?"10":Helper.toScaleValue(e.element.fontSize,this.state.height)+"px"}}>Text</span>
                                        :
                                            <div className={e.element.enable?"glyphicon glyphicon-picture":"glyphicon glyphicon-ban-circle"} aria-hidden="true"/>
                                        }

                                      </div>
                                 }
                                </ResizableBox>
                              </div>
                            </Draggable>
                          )
                        } else {

                          return   <div style={{position: "absolute",zIndex:"10"}} key={e.element.key}>
                                            <div style={{position: "absolute",top: (e.element.y-17)+"px",left:(e.element.x)+"px",width:"200px",lineHeight: "1"}}>
                                            <span style={{color:'rgba(0,0,0,0.7)',fontSize:"10px"}}>{e.element.title}</span>
                                            </div>
                                            <div key={e.element.key} style={{overflow: "hidden",position:"absolute", border: "solid 1px #555",background:e.element.enable?'rgba(0,0,255,0.4)':'rgba(0,0,0,0.1)',display: "flex", alignItems: e.element.valign, justifyContent: e.element.align,  top: e.element.y+"px",left: e.element.x+"px",width: e.element.width+"px",height: e.element.height+"px"}} >
                                              {e.element.elementType==='dataText'||e.element.elementType==='text'?
                                                <span style={{fontFamily: e.element.font===undefined?"Arial, Helvetica, sans-serif":e.element.font, color:e.element.fontColor, fontSize: e.element.fontSize===undefined?"10":Helper.toScaleValue(e.element.fontSize,this.state.height)+"px"}}>Text</span>
                                                :e.element.elementType  === 'image' ?
                                                    <img alt="" src={_GPY.resource("upload/"+e.element.imageSrc)} className="" style={{opacity: '0.30'}}/>
                                                :
                                                <div className={e.element.enable?"glyphicon glyphicon-picture":"glyphicon glyphicon-ban-circle"} aria-hidden="true"/>
                                                }
                                            </div>
                                   </div>
                        }
                    }) :    ""}
                </div>
            </div>




                {this.state.currentOverlayElement.id > 0?
                  <Draggable cancel="input" key="condfigPanel">
                  <div className="card shadow bg-light" style={{opacity:"0.9",zIndex:2000,position:"absolute", top:"100px",right:"50px"}}>
                  <div className="card-header" style={{cursor: "pointer",opacity:"1"}} >{_GPY.i18n.get('gametype_overlayconfig_element_config_window_headline')}</div>

                  <div className="p-2" style={{width:"300px",height:"700px",overflowY: "scroll"}}>
                      <h5>Allgemein</h5>
                      <div className="row">
                        <div className="col">
                          <div className="form-group form-check">
                            <input type="checkbox" className="form-check-input" id="elementEnabled" checked={this.state.currentOverlayElement.enable} onChange={this.onEnableElement.bind(this)}/>
                            <label className="form-check-label" htmlFor="elementEnabled">Aktiv</label>
                          </div>
                        </div>
                      </div>

                      {_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                            <label className="form-check-label" htmlFor="elementEnabled">{_GPY.i18n.get('gametype_overlayconfig_element_config_window_type_title')}</label>
                            <select className="form-control" value={this.state.currentOverlayElement.elementType}  onChange={this.onChangeElementType.bind(this)}>
                              <option value="dataText">DataText</option>
                              <option value="dataKeyText">DataKeyText</option>
                              <option value="dataImage">DataImage</option>
                              <option value="timerText">TimerText</option>
                              <option value="AnalogClock">AnalogClock</option>

                              <option value="text">Text</option>
                              <option value="image">Image</option>
                              <option value="colors">Colors</option>
                              <option value="special">special</option>
                            </select>
                          </div>
                        </div>
                      </div>
                     :""}

                      <hr/>
                      <h5>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_alignment_title')}</h5>
                      <div className="row">
                        <div className="col-6">
                        <div className="btn-group">
                          <button className="btn btn-light" onClick={this.setAlign.bind(this,this.state.currentOverlayElement,"flex-start")}><span className="glyphicon glyphicon-align-left" aria-hidden="true"/></button>
                          <button className="btn btn-light" onClick={this.setAlign.bind(this,this.state.currentOverlayElement,"center")}><span className="glyphicon glyphicon-align-center" aria-hidden="true"/></button>
                          <button className="btn btn-light" onClick={this.setAlign.bind(this,this.state.currentOverlayElement,"flex-end")}><span className="glyphicon glyphicon-align-right" aria-hidden="true"/></button>
                        </div>
                        </div>
                        <div className="col-6">
                        <div className="btn-group pl-1">
                          <button className="btn btn-light" onClick={this.setVAlign.bind(this,this.state.currentOverlayElement,"flex-start")}><span className="glyphicon glyphicon-object-align-top" aria-hidden="true"/></button>
                          <button className="btn btn-light" onClick={this.setVAlign.bind(this,this.state.currentOverlayElement,"center")}><span className="glyphicon glyphicon-object-align-horizontal" aria-hidden="true"/></button>
                          <button className="btn btn-light" onClick={this.setVAlign.bind(this,this.state.currentOverlayElement,"flex-end")}><span className="glyphicon glyphicon-object-align-bottom" aria-hidden="true"/></button>
                        </div>
                        </div>
                      </div>



                      <hr/>
                      <h5>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_transparency_title')}</h5>
                      <div className="row">
                      <div className="col">
                          <div className="form-group">
                              <select className="form-control" value={Math.floor(this.state.currentOverlayElement.opacity*100)}  onChange={this.onChangeElementOpacity.bind(this)}>
                                <option value='10'>10%</option>
                                <option value='20'>20%</option>
                                <option value='30'>30%</option>
                                <option value='40'>40%</option>
                                <option value='50'>50%</option>
                                <option value='60'>60%</option>
                                <option value='70'>70%</option>
                                <option value='80'>80%</option>
                                <option value='90'>90%</option>
                                <option value='100'>100%</option>
                                </select>
                            </div>
                      </div>
                    </div>

{this.state.currentOverlayElement.elementType === 'dataText' || this.state.currentOverlayElement.elementType ==='text' || this.state.currentOverlayElement.elementType ==='timerText' || this.state.currentOverlayElement.elementType ==='dataKeyText'?
                      <div>
                      <hr/>
                      <h5>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_font_title')}</h5>
                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                              <label htmlFor="gameName">{_GPY.i18n.get('gametype_overlayconfig_element_config_window_fontsize_title')}</label>
                              <select className="form-control" value={this.state.currentOverlayElement.fontSize}  onChange={this.onChangeElementFontSize.bind(this)}>
                                {fontSizes.map( (s) =>
                                    <option key={s} value={s}>{s}% ({"4k="+ Math.round(2160*s/100)+"px, FullHD="+Math.round(1080*s/100)+"px, HD="+Math.round(720*s/100)+"px"})</option>
                                )}
                              </select>
                          </div>
                        </div>

                        <div className="col">
                            <div className="form-group">
                                <label htmlFor="gameName"><span style={{fontFamily: this.state.currentOverlayElement.font===undefined?"Arial, Helvetica, sans-serif":this.state.currentOverlayElement.font}}>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_fontstyle_title')}</span></label>
                                <select className="form-control" value={this.state.currentOverlayElement.font}  onChange={this.onChangeElementFont.bind(this)}>

                                  {_GPY.userFonts!==undefined?_GPY.userFonts.map((f)=>{
                                    return (<option value={_GPY.fontUrlToName(f)}>{_GPY.fontUrlToName(f)}</option>);
                                  }):""}

                                  <option value='Arial, Helvetica, sans-serif'>Arial</option>
                                  <option value='"Arial Black", Gadget, sans-serif'>Arial Black</option>
                                  <option value='"Comic Sans MS", cursive, sans-serif'>Comic Sans MS</option>
                                  <option value='Impact, Charcoal, sans-serif'>Impact</option>
                                  <option value='"Lucida Sans Unicode", "Lucida Grande", sans-serif'>Lucida Sans Unicode</option>
                                  <option value='Tahoma, Geneva, sans-serif'>Tahoma</option>
                                  <option value='"Trebuchet MS", Helvetica, sans-serif'>Trebuchet MS</option>
                                  <option value='Verdana, Geneva, sans-serif'>Verdana</option>
                                  <option value='"Courier New", Courier, monospace'>Courier New</option>
                                  <option value='"Lucida Console", Monaco, monospace'>Lucida Console</option>
                                  <option value='"Roboto", sans-serif'>Roboto</option>
                                  <option value='"Mountains of Christmas", cursive'>Mountains of Christmas</option>
                                  <option value='"Russo One", sans-serif'>Russo One</option>
                                  <option value='"Sniglet", cursive'>Sniglet</option>
                                  <option value='"Anton", sans-serif'>Anton</option>
                                  <option value='"Lobster", cursive'>Lobster</option>
                                  <option value='"Yanone Kaffeesatz", sans-serif'>Yanone Kaffeesatz</option>
                                  <option value='"Kanit", sans-serif'>Kanit</option>
                                  <option value='"Teko", sans-serif'>Teko</option>
                                  <option value='"Cinzel", serif'>Cinzel</option>
                                  <option value='"Rubik Mono One", sans-serif'>Rubik Mono One</option>
                                  <option value='"Lobster Two", cursive'>Lobster Two</option>
                                  <option value='"Monoton", cursive'>Monoton</option>
                                  <option value='"Josefin Slab", serif'>Josefin Slab</option>
                                  <option value='"Playball", cursive'>Playball</option>
                                  <option value='Gotham bold'>Gotham bold</option>


                                </select>
                              </div>
                        </div>

                      </div>

                      <div className="row">
                      <div className="col">
                          <div className="form-group">
                              <label htmlFor="gameName"><div style={{lineHeight: this.state.currentOverlayElement.lineHeight===undefined?"1.0":this.state.currentOverlayElement.lineHeight}}>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_lineheight_title')}<br/>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_lineheight_title')}</div></label>
                              <select className="form-control" value={this.state.currentOverlayElement.lineHeight} onChange={this.onChangeElementlLineHeight.bind(this)}>
                                { function() {
                                  var rows=[];
                                  for ( var i = 0.5; i <= 5.0; i = i+0.05 ) {
                                    rows.push(<option value={i.toFixed(2)}>{i.toFixed(2)}</option>);
                                  }
                                  return rows;
                                }() }
                              </select>
                            </div>
                      </div>

                    </div>

                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                            <label htmlFor="gameName">{_GPY.i18n.get('gametype_overlayconfig_element_config_window_fontcolor_title')}</label>
                            <div style={{position: 'absolute',zIndex:5}}>
                              <button style={{backgroundColor:this.state.currentOverlayElement.fontColor, color: this.isBrightColor(this.state.currentOverlayElement.fontColor)?"#000000":'#ffffff'}} type="button" className="btn btn-secondary" onClick={this.toogleColorPicker.bind(this)}><span className="glyphicon glyphicon-edit"/>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_fontcolor_button_pick')}</button>
                              {this.state.showColorPicker?<SwatchesPicker width={220} color={ this.state.currentOverlayElement.fontColor } onChangeComplete={ this.handleColorChangeComplete.bind(this) } />:""}
                            </div>
                        </div>
                        <br/>
                        </div>
                     </div>
                      </div>
:""}
{this.state.currentOverlayElement.elementType === 'image'?
                      <div>
                        <hr/>
                        <h5>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_image_title')}</h5>
                        <div className="form-group">
                            <GpyFileUpload title="upload Image" className="btn btn-secondary mr-2" callBack={this.onElementImageUpload.bind(this)}/>
                            <img onLoad={this.imageLoaded.bind(this)} id="elementImagePreview" style={{maxWidth : '300px',maxHeight : '75px'}} src={_GPY.resource("upload/" + this.state.currentOverlayElement.imageSrc)} className="img-fluid" alt=""/>
                        </div>
                      </div>
:""}
{this.state.currentOverlayElement.elementType === 'timerText' && _GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
  <div>
                      <hr/>
                      <h5>Rules</h5>
                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                              <label htmlFor="gameName">min (ms)</label>
                                <input  name="gameName" type="text"  onChange={this.onChangeValue.bind(this,"timerMin")} value={this.state.currentOverlayElement.timerMin} className="form-control" placeholder="0"/>
                          </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                              <label htmlFor="gameName">max (ms)</label>
                                <input  name="gameName" type="text"  onChange={this.onChangeValue.bind(this,"timerMax")} value={this.state.currentOverlayElement.timerMax} className="form-control" placeholder="5400000"/>
                              </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="form-group">
                              <label htmlFor="gameName">displayFrom (ms)</label>
                                <input  name="gameName" type="text"  onChange={this.onChangeValue.bind(this,"timerDisplayFrom")} value={this.state.currentOverlayElement.timerDisplayFrom} className="form-control" placeholder="0"/>
                          </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                              <label htmlFor="gameName">displayUntil (ms)</label>
                                <input  name="gameName" type="text"  onChange={this.onChangeValue.bind(this,"timerDisplayUntil")} value={this.state.currentOverlayElement.timerDisplayUntil} className="form-control" placeholder="5400000"/>
                              </div>
                        </div>
                      </div>

                      <div className="row">

                        <div className="col">
                            <div className="form-group">
                              <label htmlFor="gameName">timerOffset (ms)</label>
                                <input  name="gameName" type="text"  onChange={this.onChangeValue.bind(this,"timerOffset")} value={this.state.currentOverlayElement.timerOffset} className="form-control" placeholder="0"/>
                              </div>
                        </div>
                      </div>
</div>
:""}
{_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
                      <div className="row">

                        <div className="col">
                            <div className="form-group">
                              <label htmlFor="gameName">displayRule</label>
                                <input  name="gameName" type="text"  onChange={this.onChangeValue.bind(this,"displayRule")} value={this.state.currentOverlayElement.displayRule} className="form-control" placeholder=""/>
                              </div>
                        </div>
                      </div>
: <div/>
}

                      <hr/>
                      <h5>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_position_title')}</h5>

                        <div className="d-flex w-100 justify-content-between">

                            <span type="text" style={{width:"20%"}}>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_position_x')}</span>
                            {this.state._EDIT_X?

                              <div className="form-group" style={{width:"60%"}}>
                                 <input className="form-control" type="text" onChange={(e)=>{ var v = parseFloat(e.target.value.replace(",",".")); if(!isNaN(v) && v>=0 && v<=100){this.setState({"_EDIT_X_NUM":v}); console.log(v);}}} defaultValue={this.state._EDIT_X_NUM} />
                                 <button onClick={()=>{var ov = this.state.currentOverlayElement; ov.x = Helper.toXPos(this.state._EDIT_X_NUM,this.state.width); this.setState({"currentOverlayElement":ov,"_EDIT_X":false})}} className="btn btn-primary btn-sm">OK</button>
                                 <button onClick={()=>{this.setState({"_EDIT_X":false})}} className="btn btn-secondery btn-sm">Cancel</button>
                             </div>
                              :
                                <span style={{width:"60%"}}>{Helper.toXPercent(this.state.currentOverlayElement.x,this.state.width).toFixed(4)} % <button type="button" className="btn btn-light btn-sm" onClick={()=>{this.setState({"_EDIT_X_NUM":Helper.toXPercent(this.state.currentOverlayElement.x,this.state.width).toFixed(4), "_EDIT_X":true})}}><span className="glyphicon glyphicon-pencil" aria-hidden="true"/></button></span>
                            }

                          </div>
                          <div className="d-flex w-100 justify-content-between">

                          <span style={{width:"20%"}}>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_position_y')}</span>
                          {this.state._EDIT_Y?

                            <div className="form-group" style={{width:"60%"}}>
                               <input className="form-control" type="text" onChange={(e)=>{ var v = parseFloat(e.target.value.replace(",",".")); if(!isNaN(v) && v>=0 && v<=100){this.setState({"_EDIT_Y_NUM":v}); console.log(v);}}} defaultValue={this.state._EDIT_Y_NUM} />
                               <button onClick={()=>{var ov = this.state.currentOverlayElement; ov.y = Helper.toXPos(this.state._EDIT_Y_NUM,this.state.height); this.setState({"currentOverlayElement":ov,"_EDIT_Y":false})}} className="btn btn-primary btn-sm">OK</button>
                               <button onClick={()=>{this.setState({"_EDIT_Y":false})}} className="btn btn-secondery btn-sm">Cancel</button>
                           </div>
                            :
                              <span style={{width:"60%"}}>{Helper.toYPercent(this.state.currentOverlayElement.y,this.state.height).toFixed(4)} % <button type="button" className="btn btn-light btn-sm" onClick={()=>{this.setState({"_EDIT_Y_NUM":Helper.toYPercent(this.state.currentOverlayElement.y,this.state.height).toFixed(4), "_EDIT_Y":true})}}><span className="glyphicon glyphicon-pencil" aria-hidden="true"/></button></span>
                          }
                        </div>

                        <div className="d-flex w-100 justify-content-between">
                          <span style={{width:"20%"}}>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_position_width')}</span>
                      {/*    <span style={{width:"30%"}}>{Helper.toXPercent(this.state.currentOverlayElement.width,this.state.width).toFixed(2)}%</span>
*/}
                        {this.state._EDIT_W?

                            <div className="form-group" style={{width:"60%"}}>
                               <input className="form-control" type="text" onChange={(e)=>{ var v = parseFloat(e.target.value.replace(",",".")); if(!isNaN(v) && v>=0 && v<=100){this.setState({"_EDIT_W_NUM":v}); console.log(v);}}} defaultValue={this.state._EDIT_W_NUM} />
                               <button onClick={()=>{var ov = this.state.currentOverlayElement; ov.width = Helper.toXPos(this.state._EDIT_W_NUM,this.state.width); this.setState({"currentOverlayElement":ov,"_EDIT_W":false})}} className="btn btn-primary btn-sm">OK</button>
                               <button onClick={()=>{this.setState({"_EDIT_W":false})}} className="btn btn-secondery btn-sm">Cancel</button>
                           </div>
                            :
                              <span style={{width:"60%"}}>{Helper.toXPercent(this.state.currentOverlayElement.width,this.state.width).toFixed(4)} % <button type="button" className="btn btn-light btn-sm" onClick={()=>{this.setState({"_EDIT_W_NUM":Helper.toXPercent(this.state.currentOverlayElement.width,this.state.width).toFixed(4), "_EDIT_W":true})}}><span className="glyphicon glyphicon-pencil" aria-hidden="true"/></button></span>
                          }

                          </div>
                          <div className="d-flex w-100 justify-content-between">

                          <span style={{width:"20%"}}>{_GPY.i18n.get('gametype_overlayconfig_element_config_window_position_height')}</span>

                          {/*  <span style={{width:"30%"}}>{Helper.toXPercent(this.state.currentOverlayElement.height,this.state.height).toFixed(2)}%</span>
                          */}
                          {this.state._EDIT_H?

                            <div className="form-group" style={{width:"60%"}}>
                               <input className="form-control" type="text" onChange={(e)=>{ var v = parseFloat(e.target.value.replace(",",".")); if(!isNaN(v) && v>=0 && v<=100){this.setState({"_EDIT_H_NUM":v}); console.log(v);}}} defaultValue={this.state._EDIT_H_NUM} />
                               <button onClick={()=>{var ov = this.state.currentOverlayElement; ov.height = Helper.toYPos(this.state._EDIT_H_NUM,this.state.height); this.setState({"currentOverlayElement":ov,"_EDIT_H":false})}} className="btn btn-primary btn-sm">OK</button>
                               <button onClick={()=>{this.setState({"_EDIT_H":false})}} className="btn btn-secondery btn-sm">Cancel</button>
                           </div>
                            :
                              <span style={{width:"60%"}}>{Helper.toYPercent(this.state.currentOverlayElement.height,this.state.height).toFixed(4)} % <button type="button" className="btn btn-light btn-sm" onClick={()=>{this.setState({"_EDIT_H_NUM":Helper.toYPercent(this.state.currentOverlayElement.height,this.state.height).toFixed(4), "_EDIT_H":true})}}><span className="glyphicon glyphicon-pencil" aria-hidden="true"/></button></span>
                         }
                        </div>


{_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
  <div>
                      <hr/>
                      <h5>Inhalt</h5>
                      <div className="form-group">
                          <label htmlFor="gameName">Script</label>
                          <input  name="gameName" type="text"  onChange={this.onChangeDataSouce.bind(this)} value={this.state.currentOverlayElement.dataSource} className="form-control" placeholder="dataPath"/>
                      </div>
                      <div className="form-group">
                          <label htmlFor="gameName">ImgSouce</label>
                          <input  name="gameName" type="text"  onChange={this.onChangeImageSouce.bind(this)} value={this.state.currentOverlayElement.imageSrc} className="form-control" placeholder="imageSrc"/>
                      </div>
                      </div>
:""}



                  </div>

                  </div>
      </Draggable>
                :""}



            </div>

          </div>
       </div>
      </div>


		 	);
    }
}
export default OverlayConfig;
